import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useColumnMatchesQuery } from '../../api/taskColumnsApi';
import { fmtDateIST } from '../../utils/dates';
import ColumnRow from './ColumnRow';

/** The full match list for one column — "show all" past the handful the board shows inline. */
export default function ColumnMatchesModal({ column, anchor, actions, onClose }) {
  const [page, setPage] = useState(1);
  const pageSize = 50;
  const { data, isFetching } = useColumnMatchesQuery({ id: column.id, anchor, page, pageSize });

  const items = data?.items ?? [];
  const total = data?.totalCount ?? 0;
  const lastPage = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>{column.name}</h2>
            <div className="td-muted" style={{ fontSize: '0.78rem' }}>
              {column.ruleSummary} · as of {fmtDateIST(anchor)}
            </div>
          </div>
          <button type="button" className="modal-close" onClick={onClose}><X size={18} /></button>
        </div>

        <div className="modal-body">
          {isFetching && items.length === 0 && <div className="skeleton" style={{ height: 60 }} />}

          {!isFetching && items.length === 0 && (
            <div className="col-empty">Nobody matches on this date.</div>
          )}

          <div style={{ display: 'grid', gap: 6 }}>
            {items.map((row) => (
              <ColumnRow key={row.matchToken} row={row} columnId={column.id} actions={actions} />
            ))}
          </div>
        </div>

        <div className="modal-footer" style={{ justifyContent: 'space-between' }}>
          <span className="td-muted" style={{ fontSize: '0.8rem' }}>
            {total === 0 ? 'No matches' : `Showing ${(page - 1) * pageSize + 1}–${Math.min(page * pageSize, total)} of ${total}`}
          </span>
          <span style={{ display: 'inline-flex', gap: 6 }}>
            <button className="btn btn-outline btn-sm" disabled={page <= 1} onClick={() => setPage((p) => p - 1)}>
              Previous
            </button>
            <button className="btn btn-outline btn-sm" disabled={page >= lastPage} onClick={() => setPage((p) => p + 1)}>
              Next
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}
